import React, { useEffect, useRef, useState } from 'react';

const Hero = () => {
  const videoRef = useRef(null);
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  useEffect(() => {
    // Create link preload in the document head
    const videoPreloadLink = document.createElement('link');
    videoPreloadLink.rel = 'preload';
    videoPreloadLink.href = '/videos/hero-bg.mp4';
    videoPreloadLink.as = 'video';
    videoPreloadLink.type = 'video/mp4';
    document.head.appendChild(videoPreloadLink);
    
    // Prefetch the video
    const prefetchVideo = () => {
      const videoElement = videoRef.current;
      if (videoElement) {
        videoElement.playbackRate = 0.75;
        
        // Try to load the video as soon as possible
        videoElement.load();
      }
    };
    
    // Use requestIdleCallback if available, otherwise use setTimeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchVideo);
    } else {
      setTimeout(prefetchVideo, 0);
    }
    
    return () => {
      // Clean up the preload link when component unmounts
      if (document.head.contains(videoPreloadLink)) {
        document.head.removeChild(videoPreloadLink);
      }
    };
  }, []);

  const handleVideoError = (e) => {
    console.error('Video error:', e);
    setIsVideoLoading(false); // Show background in case of error
  };

  const handleVideoLoad = () => {
    console.log('Video loaded successfully');
    setIsVideoLoading(false);
  };

  return (
    <div className="hero-wrapper">
      <div className="video-container">
        <video 
          ref={videoRef}
          className={`hero-video ${isVideoLoading ? 'is-loading' : ''}`}
          autoPlay 
          loop 
          muted 
          playsInline
          preload="auto"
          onError={handleVideoError}
          onLoadedData={handleVideoLoad}
        >
          <source src="/videos/hero-bg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="overlay-container">
        <div className="gradient-overlay"></div>
      </div>
      <div className="hero-content">
        <h3>Your Trusted Partner<br />in Medical Transportation</h3>
        <div className="hero-subtext">
          <p>We strive to provide top quality care and compassion for all clients.</p>
          <p>It is our goal to ensure your ride is safe, comfortable and always on time.</p>
        </div>
      </div>
    </div>
  );
};

export default Hero; 